import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules, productImage } from '../data/content';
import { scrollToPricing } from './CTAButton';
export function ModulesSection() {
  return <section className="bg-white px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="solution-heading" data-id="element-87" data-mp="1iv1sl8ux5mn5">
      <div className="mb-2.5 text-center" data-id="element-88" data-mp="1dwqfmp9buw0p">
        <h2 id="solution-heading" className="mb-1 text-[19px] font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-89" data-mp="1dy1lqvq8wfuz">
          La Soluzione che Stavi Cercando
        </h2>
        <p className="mb-2 font-heading text-[11px] font-extrabold uppercase tracking-wide text-brand-green sm:text-sm" data-id="element-90" data-mp="26lxiu1jq89sa">
          Un Sistema Completo 6-in-1 per Istruttori e Maestri di Padel
        </p>
        <button type="button" onClick={scrollToPricing} className="mb-2 block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Vai alla sezione di acquisto" data-id="element-91" data-mp="1wp2h79s5pt9s">
          <img src={productImage} alt="Il cofanetto PADEL MASTER PRO con i 6 moduli" className="mx-auto w-full max-w-[240px] object-contain drop-shadow-lg transition-transform duration-200 hover:scale-[1.02]" data-id="element-92" data-mp="1ivia11pvf20o" />
        </button>
        <p className="text-[17px] font-extrabold uppercase leading-tight text-brand-navy sm:text-xl" data-id="element-93" data-mp="18zf5jp7jqrak">
          PADEL MASTER PRO™
        </p>
        <p className="mt-1 text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-94" data-mp="104h8c5xd8sdf">
          Più di una raccolta di esercizi. Più di una semplice libreria di materiali. PADEL MASTER
          PRO™ è un sistema professionale progettato per permetterti di preparare lezioni, esercizi,
          progressioni e programmi in pochi minuti, lavorando ogni giorno con materiale professionale
          già pronto.
        </p>
      </div>
      <div className="space-y-1.5" data-id="element-95" data-mp="h6oh40w3u6vv">
        {modules.map(module => <article key={module.title} className="flex gap-2.5 rounded-lg border border-brand-navy/10 bg-brand-gray p-2.5 shadow-sm sm:p-3" data-id="element-96" data-mp="l66rw3u7p1kz">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-green" data-id="element-97" data-mp="2j2x5pm52wxro">
              <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-98" data-mp="2e5doqegzy6w1" />
            </span>
            <div data-id="element-99" data-mp="296ajou10o0o2">
              <h3 className="mb-0.5 text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-100" data-mp="296u189mr8n1k">
                {module.title}
              </h3>
              <p className="text-[11.5px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-101" data-mp="31u6flwirhojs">
                {module.description}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}